// Auth utility functions

export const getToken = () => localStorage.getItem('token');

export const getUser = () => {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      return JSON.parse(userStr);
    } catch {
      return null;
    }
  }
  return null;
};

export const setAuth = (token, user) => {
  // Token is now stored in httpOnly cookie by server
  // We still store it in localStorage for backward compatibility
  // but the cookie will be used for authentication
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
};

export const clearAuth = async () => {
  // Clear localStorage
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  
  // Also clear the httpOnly cookie via API call
  // Import dynamically to avoid circular dependency
  try {
    const { logout: apiLogout } = await import('./api');
    await apiLogout();
  } catch (err) {
    // Ignore errors when logging out
    console.debug('Logout API call failed:', err);
  }
};

export const isAuthenticated = () => {
  const token = getToken();
  const user = getUser();
  return !!token && !!user;
};

export const isAdmin = () => {
  const user = getUser();
  return user?.role === 'admin';
};

export const isOrgUser = () => {
  const user = getUser();
  return user?.role === 'org_user';
};

export const getUserOrgId = () => {
  const user = getUser();
  return user?.org_id;
};

export const getUserName = () => {
  const user = getUser();
  return user?.name || 'User';
};

export const getUserEmail = () => {
  const user = getUser();
  return user?.email || '';
};
